import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import RegularButton from "../../components/Buttons/RegularButton";
import {
  useLoginSendOtpMutation,
  useLoginverifyOtpMutation,
  useLogoutUserMutation,
  useSsoLoginUserMutation,
} from "../../redux/services/authApi";
import { useSelector } from "react-redux";
import MuiAlert from "../../pages/MuiAlert/MuiAlert";
import OTPInput from "react-otp-input";
import Loader from "../../pages/commons/Loading";
import { reset, resetIsNavigation, setAuth } from "../../redux/slices/authSlice";
import { resetCustomer, setCustomer } from "../../redux/slices/customerSlice";
import { useAppDispatch } from "../../redux/app/hooks";
import { useLocation } from "react-router-dom";
import { useFindCustomerDetailByIdMutation } from "../../redux/services/customerService";
import toast from "react-hot-toast";
import { resetNav } from "../../redux/slices/navSlice";
import { resetParkings } from "../../redux/slices/parkingSlice";

type Props = {};

const OtpVerification = (props: Props) => {
  const [value, setValue] = useState("");
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const navigate = useNavigate();
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [isResendDisabled, setResendDisabled] = useState(false);
  const [timer, setTimer] = useState(60);
  const [loginUser, loginUserResponse] = useLoginSendOtpMutation();
  const [verifyOTP, OTPResponse] = useLoginverifyOtpMutation();
  const navigationParams: any = useLocation();
  const [user, setUser] = useState(navigationParams.state.ssoLogindata);
  const [data, setData] = useState(navigationParams.state.Mobile);
  const [logoutUser, logoutResponse] = useLogoutUserMutation();

  const dispatch = useAppDispatch();
  const [seconds, setSeconds] = useState(60);

  let valueForOTP = value.length;

  const handleLogin = () => {
    verifyOTP({
      phoneNo: data === true ? user : "",
      category: "UTCUST",
      emailFlag: data === true ? false : true,
      email: data === true ? "" : user.toLowerCase(),
      otp: value,
    });
  };
  const [findCustomerDetailById, findCustomerDetailByIdResponse] =
    useFindCustomerDetailByIdMutation();
  useEffect(() => {
    if (OTPResponse.isSuccess) {
      if (OTPResponse?.data?.jwtToken !== null) {
        findCustomerDetailById({
          token: OTPResponse?.data?.jwtToken,
          id: OTPResponse?.data?.customerId,
        });
      }
    }

    if (OTPResponse.isError) {
      const newpage: any = OTPResponse?.error;
      const errorCode: any = newpage.data?.serviceErrors[0].errorCode;
      const newMsg: any = newpage.data?.serviceErrors[0].msg;
      setStatusCode({
        type: "error",
        code: errorCode
          ? errorCode === "INVALID_OTP_EXCEPTION"
            ? newMsg
            : newMsg
          : "CONSENT_FORM_ERROR",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [OTPResponse.isSuccess, OTPResponse.isError]);

  useEffect(() => {
    if (findCustomerDetailByIdResponse.isSuccess) {
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("user", JSON.stringify(OTPResponse.data));
      dispatch(setAuth(OTPResponse.data));
      dispatch(setCustomer(findCustomerDetailByIdResponse.data));
      dispatch(resetIsNavigation(false));
      dispatch(setAuth(OTPResponse.data));
      navigate("/");
    } else if (findCustomerDetailByIdResponse.isError) {
      toast.error("Session expired. Please login!!!");
      localStorage.removeItem("user");
      localStorage.setItem("isLoggedIn", "false");
      dispatch(resetCustomer());
      dispatch(resetParkings());
      dispatch(resetNav());
      logoutUser({});
      dispatch(reset());
    }
  }, [
    findCustomerDetailByIdResponse.isSuccess,
    findCustomerDetailByIdResponse.isError,
  ]);

  useEffect(() => {
    if (logoutResponse.isSuccess) {
      navigate("/");
    }
  }, [logoutResponse.isSuccess]);

  const resendOTP = () => {
    loginUser({
      phoneNo: data === true ? user : "",
      category: "UTCUST",
      emailFlag: data === true ? false : true,
      email: data === true ? "" : user.toLowerCase(),
    });
  };

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [seconds]);

  useEffect(() => {
    setStatusCode({
      type: "success",
      code:
        data === false
          ? "OTP has been successfully sent to your registered email"
          : "OTP has been successfully sent to your registered phone number",
    });
    setIsAlertVisible(true);
    setTimeout(() => {
      setIsAlertVisible(false);
    }, 5000);
  }, []);

  useEffect(() => {
    if (loginUserResponse.isSuccess) {
      setSeconds(60);
      setStatusCode({
        type: "success",
        code:
          data === false
            ? "OTP has been successfully sent to your registered email"
            : "OTP has been successfully sent to your registered phone number",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [loginUserResponse.isSuccess]);

  return (
    <div>
      <div className="">
        <div className="w-[90%] flex lg:hidden  m-2  ">
          <NavLink to={"/"}>
            <img
              src={require("../../assets/logo.png")}
              alt=""
              className="md:w-[50px] w-[40px]"
            />
          </NavLink>
        </div>

        <div className="md:mx-[10px] mx-[4px]">
          <div
            className=" w-full  p-3 flex items-center lg:hidden  md:flex-col"
            style={{
              background: `rgb(226 55 68) center center no-repeat`,
              backgroundSize: "cover",
            }}
          >
            <div className="  flex justify-center flex-col">
              <img
                src={require("../../assets/slide3.png")}
                className="w-full"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row ">
        <div className=" h-[100%] mt-[10px]  lg:w-1/2 w-full  md:px-10 justify-center ">
          <div className="mt-[35px] lg:flex hidden">
            <NavLink to={"/"}>
              <img
                src={require("../../assets/logo.png")}
                alt=""
                className="w-[50px]"
              />
            </NavLink>
          </div>

          <div className="md:flex md:items-center lg:mt-[50px] md:mt-0 mt-[10px] justify-center flex-col flex items-center">
            {isAlertVisible && (
              <div>
                <MuiAlert
                  severity={statusCode?.type!}
                  messageType={statusCode?.code!}
                />
              </div>
            )}
            <div className="md:m-[3.4rem]  ">
              <h1 className="md:text-[32px] text-[22px] mt-[30px] mb-[24px] ml-4  text-[#475467] font-medium">
                OTP Verification
              </h1>

              <OTPInput
                value={value}
                onChange={setValue}
                numInputs={6}
                containerStyle={{ border: "none" }}
                inputStyle={{
                  width: "40px",
                  height: "40px",
                  marginLeft: "20px",
                  borderRadius: "5px",
                  border: "2px solid black",
                }}
                renderInput={(props) => <input {...props} />}
                shouldAutoFocus={true}
              />
              {seconds === 0 ? null : (
                <p className="text-red-500 text-center mt-4 text-base">
                  The OTP will expire in {seconds} sec
                </p>
              )}

              <p className="flex justify-center mb-0 gap-2 text-gray-500 py-6 cursor-default">
                I didn't receive the code?{" "}
                <button
                  className={`underline text-red-500 ${
                    seconds == 0 ? "text-red-500" : "cursor-not-allowed"
                  }`}
                  disabled={seconds == 0 ? false : true}
                  onClick={() => {
                    setValue("");
                    resendOTP();
                  }}
                >
                  Resend
                </button>
              </p>

              <div className="lg:flex sm:flex-row items-center gap-5 mt-5 ">
                <RegularButton
                  disabled={valueForOTP === 6 ? false : true}
                  onClick={() => {
                    handleLogin();
                  }}
                  className="w-[100%] md:w-[400px]"
                  title={"Submit"}
                />
              </div>
              <p className="flex justify-center mb-0 gap-2 text-gray-500 py-6 cursor-default">
                Go back to{" "}
                <span
                  className="text-red-500 cursor-pointer underline"
                  onClick={() => {
                    navigate("/profile/auth/login");
                  }}
                >
                  Login
                </span>
              </p>
            </div>
          </div>
          <p className="text-[#8A8A8A] mt-[300px]">
            © 2024 CarRental. All Rights Reserved
          </p>
        </div>
        <div
          className=" w-1/2 hidden p-[58px] 2xl:h-[100vh] lg:flex lg:items-center  lg:flex-col"
          style={{
            background: `rgb(226 55 68) center center no-repeat`,
            backgroundSize: "cover",
          }}
        >
          <div className=" flex lg:h-[100%] xl:h-[768px] mt-2 2xl:h-[100%] justify-center">
            <img
              src={require("../../assets/auth1.png")}
              className="w-[700px] 2xl:w-[1000px] mb-[10px] md:mb-0"
              alt=""
            />
          </div>
        </div>
      </div>
      {loginUserResponse.isLoading || OTPResponse.isLoading ? <Loader /> : null}
    </div>
  );
};

export default OtpVerification;
